import { Filter, ConditionValueTypes, ConditionValue } from 'app/components/filters/types';
import { valuePropName } from 'app/components/filters/filters-panel/constants';
import { getTextFieldConditionTypesValueData } from 'app/components/filters/filters-panel/filter-types/filter-text/text-field-data';
import { SelectItem } from 'ui/common/select/types';
import { trimValue } from 'app/components/filters/filters-panel/filter-types/trim-value';

export const getFavouriteConditionValue = (id: number, filter: Filter, conditionValue: ConditionValue) => {
  const newConditionValue = filter.advancedField && {
    id,
    [valuePropName.text]: trimValue(conditionValue),
    myValue: false,
    periodPredef: { v: 0 },
    ...getTextFieldConditionTypesValueData(filter.advancedField, ConditionValueTypes.default)
  };

  return trimValue(conditionValue) !== '' && newConditionValue;
};

export const createConditionValue = (id: number, filter: Filter, value: SelectItem[]) => {
  return value && (value instanceof Array
    && value.map(v => getFavouriteConditionValue(id++, filter, v.value)) || [getFavouriteConditionValue(id++, filter, value)]);
};
